<template>
  <div style="padding-bottom: 64px;">
    <!-- <van-nav-bar
      title="工作经历"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <van-form @submit="submit" class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          v-model="detail.unitName"
          placeholder="请输入公司名称"
          label="公司名称"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          v-model="detail.jobName"
          placeholder="请填写职位名称"
          label="职位名称"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          @click="schoolTime = true"
          placeholder="请选择在职时间"
          is-link
          :value="schoolTimes"
          label="在职时间"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
        <!-- <van-field
          input-align="right"
          readonly
          is-link
          clickable
          placeholder="请选择在职时间"
          label="在职时间">
          <template #input>
            <div class="work-time">
              <van-field
                input-align="center"
                v-model="detail.workStartTime"
                @click="showTime(detail.workStartTime, 'workStartTime')"
                placeholder="入职时间">
              </van-field>
              <van-field
                input-align="center"
                v-model="detail.workEndTime"
                @click="showTime(detail.workEndTime, 'workEndTime')"
                placeholder="离职时间">
              </van-field>
            </div>
          </template>
        </van-field> -->

        <van-field
          input-align="right"
          readonly
          is-link
          placeholder="请选择所属行业"
          v-model="detail.tradesName"
          @click="showSelect('tradesName', 'tradesId')"
          label="所属行业"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          readonly
          is-link
          placeholder="请选择当前月薪"
          :value="detail.salary"
          @click="showSelect('salary')"
          clickable
          label="当前月薪"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
        <van-field
          input-align="right"
          class="flex-column"
          readonly
          label="工作描述"
          v-model="detail.workDescription"
          required
          :rules="[
            { required: true, message: '请描述你在该公司的主要工作内容～' }
          ]"
        >
          <template #input>
            <textarea
              class="area"
              v-model="detail.workDescription"
              placeholder="请描述你在该公司的主要工作内容～"
            >
            </textarea>
          </template>
        </van-field>
        <div class="status">
          <p>对这家公司隐藏我的简历</p>
          <div>
            <!-- <span>关闭</span> -->
            <van-switch v-model="detail.inBlackNameList" />
          </div>
        </div>
      </van-cell-group>
      <div class="fixed-bottom">
        <van-button
          v-if="$route.query.id"
          type="primary"
          class="btn-org-border"
          color="#FFF9F9"
          round
          @click="del($route.query.id)"
          >删 除</van-button
        >
        <van-button
          type="primary"
          class="btn-blue"
          color="linear-gradient(to right top, #2F72F6,#1C54CF)"
          round
          native-type="submit"
          >保 存</van-button
        >
      </div>
    </van-form>

    <!--弹出选项-->
    <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
      <van-picker
        show-toolbar
        v-model="detail.salary"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <!--选择时间-->
    <van-popup
      v-model="schoolTime"
      round
      position="bottom"
      style="width: 100%;"
    >
      <van-tabs
        title-active-color="#2D6FF2"
        v-model="active"
        :ellipsis="false"
      >
        <van-tab>
          <template #title>
            <p>入职时间</p>
          </template>
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate.workStartTime"
            type="date"
            visible-item-count="3"
            item-height="50"
            :formatter="formatter"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </van-tab>
        <van-tab>
          <template #title>
            <p>离职时间</p>
          </template>
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate.workEndTime"
            type="date"
            visible-item-count="3"
            item-height="50"
            :formatter="formatter"
            :min-date="endMinDate"
            :max-date="endMaxDate"
            @change="endDateChange"
          />
        </van-tab>
      </van-tabs>
      <button class="btn-default" @click="getTime">确定</button>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "workHistory",
  data() {
    return {
      detail: {},
      dictTrades: [],
      active: 0,
      currentDate: {
        workStartTime: moment().subtract(3, 'year')._d,
        workEndTime: moment()._d
      },
      minDate: new Date(1990, 0, 1),
      maxDate: moment()._d,
      endMinDate: moment().subtract(3, 'year')._d,
      endMaxDate: moment()._d,
      schoolTime: false,
      schoolTimes: "",
      formatDate: "YYYY-MM-DD",
      whoShow: "",
      showTimeSelect: false,
      showPicker: false,
      type: "",
      typeId: ""
    };
  },
  computed: {
    columns() {
      const obj = {
        salary: Array.from(this.module.salaryMap.keys()),
        tradesName: this.dictTrades.map(item => {
          return item.title;
        })
      };
      return obj[this.type];
    }
  },
  methods: {
    moment,
    get() {
      this.module.api.dictTrades({
        params: { parentId: 0 },
        success: res => {
          this.dictTrades = res;
        }
      });
    },
    onload(id) {
      this.module.api.workExpDetail({
        params: { id },
        success: res => {
          for (let [key, value] of this.module.salaryMap.entries()) {
            value === res.salary && (res.salary = key);
          }
          this.schoolTimes =
            moment(res.workStartTime).format("YYYY-MM-DD") +
            " - " +
            moment(res.workEndTime).format("YYYY-MM-DD");
          this.currentDate = {
            workStartTime: new Date(res.workStartTime),
            workEndTime: new Date(res.workEndTime)
          };
          this.detail = res;
        }
      });
    },
    showSelect(type, typeId) {
      this.type = type;
      typeId && (this.typeId = typeId);
      this.showPicker = true;
    },
    filterId(name, type) {
      const obj = {
        tradesName: () =>
          this.dictTrades.filter(({ title }) => title === name)[0].id
      };
      return obj[type]();
    },
    onConfirm(val) {
      this.detail[this.type] = val;
      if (this.typeId) {
        this.detail[this.typeId] = this.filterId(val, this.type);
        this.typeId = "";
      }
      this.showPicker = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    endDateChange() {
      this.endMinDate = moment(this.currentDate.workStartTime)._d
      this.maxDate = moment(this.currentDate.workEndTime).subtract(1, 'days')._d
    },
    getTime() {
      let workStartTime = moment(this.currentDate.workStartTime).format(
        this.formatDate
      );
      let workEndTime = moment(this.currentDate.workEndTime).format(
        this.formatDate
      );
      Object.assign(this.detail, { workStartTime, workEndTime });
      this.schoolTimes = workStartTime + " - " + workEndTime;
      this.schoolTime = false;
    },
    submit() {
      const { salary, workStartTime, workEndTime } = this.detail;
      const detail = Object.assign({}, this.detail, {
        salary: this.module.salaryMap.get(this.detail.salary),
        workStartTime: moment(workStartTime).format("YYYY-MM-DD HH:mm:ss"),
        workEndTime: moment(workEndTime).format("YYYY-MM-DD HH:mm:ss")
      });
      this.module.api.workExpSubmit({
        params: detail,
        success: res => {
          this.toast("保存成功");
          this.onClickLeft();
        }
      });
    },
    del(id) {
      this.module.api.workExpDelete({
        params: { id },
        success: res => {
          this.toast("删除成功");
          this.onClickLeft();
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.get();
    this.$route.query.id && this.onload(this.$route.query.id);
  }
};
</script>

<style lang="less" scoped>
.user-img {
  position: relative;
  width: 88px;
  margin: 20px auto 40px;
  img {
    width: 88px;
    height: 88px;
  }
  i {
    position: absolute;
    right: 0;
    top: 0;
    color: #2f72f6;
    font-size: 22px;
  }
}
/deep/.van-cell {
  padding: 20px 16px;
}
/deep/.van-hairline--top-bottom::after,
/deep/.van-hairline-unset--top-bottom::after {
  display: none;
}
/deep/.van-cell__right-icon {
  transform: rotate(90deg);
  top: -4px;
}
.work-time {
  display: flex;
  /deep/.van-cell {
    padding: 0 0 10px 0;
  }
}
.flex-column {
  display: flex;
  flex-direction: column;
  /deep/.van-cell__value {
    margin-right: 0;
  }
  textarea {
    margin-top: 10px;
    font-size: 14px;
    border-radius: 4px;
    background: #f8f9fb;
    padding: 16px;
    color: #333;
    display: block;
    width: 100%;
    border: none;
    min-height: 105px;
    line-height: 1.8;
    &::-webkit-input-placeholder {
      color: #aaa;
    }
  }
}
.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 2;
  }
  .btn-org-border {
    border: 1px solid #ff5945 !important;
    box-shadow: none;
    margin-right: 16px;
    flex: 1;
    color: #ff5945;
    .van-button__text {
      color: #ff5945;
    }
  }
}
.status {
  display: flex;
  margin:16px;
  justify-content: space-between;
  align-items: center;
  position: relative;
  & > div {
    display: flex;
    align-items: center;
    span {
      margin-right: 10px;
      color: #bfc1c6;
    }
  }
  p {
    font-size: 14px;
    color: #515255;
  }
  /deep/.van-switch {
    width: 46px;
    height: 24px;
    .van-switch__node {
      width: 20px;
      height: 20px;
    }
    &.van-switch--on {
      .van-switch__node {
        right: 15px;
        left: auto;
        top: 2px;
      }
    }
    .van-switch__node {
      left: 2px;
      top: 1px;
    }
  }
}
/deep/.van-tabs--line .van-tabs__wrap {
  height: 72px;
  border-bottom: 1px solid #eee;
}
/deep/.van-tab__text {
  text-align: center;
  padding: 10px;
  display: block;
  p {
    font-size: 12px;
    transform: rotate(0.9);
    color: #5c5d5f;
  }
  span {
    font-size: 16px;
    color: #5c5d5f;
    opacity: 0.5;
  }
}
/deep/.van-tab.van-tab--active {
  span {
    color: #2d6ff2;
    opacity: 1;
  }
}
/deep/.van-tabs__line {
  background: #2d6ff2;
  width: 50%;
  margin-bottom: -1px;
  z-index: 999;
}
/deep/.van-picker-column__item {
  .van-ellipsis {
    font-size: 18px;
  }
}
.btn-default {
  color: #2a2b2c;
  width: 100%;
  font-size: 16px;
  display: block;
  border: none;
  text-align: center;
  border-top: 1px solid #eee;
  padding: 16px 0;
  background: none;
}
/deep/.van-popup {
  min-height: auto;
  border-radius: 0;
  .van-tabs__nav {
    border-radius: 16px 16px 0 0;
  }
}
</style>
